import classNames from "classnames";

const ScheduleCard = ({
  selected,
  onClick,
  title,
  subtitle,
  children,
  className = "",
}) => {
  return (
    <div
      className={classNames(
        "p-4 h-full card relative rounded-lg border cursor-default",
        {
          "bg-white": selected,
          "bg-gray-50 opacity-50 cursor-pointer": !selected,
        },
        className
      )}
      onClick={onClick}
    >
      <input type="radio" className="peer hidden" checked={selected} />
      <div className="m-4 top-0 absolute right-0 w-4 h-4 rounded-full border-2 border-neutral-dark bg-white peer-checked:bg-neutral-dark transition-all"></div>
      <div className="font-semibold">{title}</div>
      <div className="font-medium text-gray-600 pb-3">{subtitle}</div>
      {children}
    </div>
  );
};

export default ScheduleCard;
